import React, { useEffect } from 'react';
import DefaultAd from '../ads/default/DefaultAd';
import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../redux/store';
// import { getAdvertisement } from '../../redux/slices/advertisement';
import parse from 'html-react-parser';

const Ads = () => {
	const dispatch = useAppDispatch();

	const advertisementHTML = useAppSelector((state) => state.advertisement.currentAdvertisement) as string;

	const advertisementStatus = useAppSelector((state) => state.advertisement.status);

	useEffect(() => {
		if (!advertisementHTML) {
			// dispatch(getAdvertisement());
		}
	}, [dispatch, advertisementHTML]);

	if (!advertisementHTML && advertisementStatus === 'loading') {
		return <>loading...</>;
	}

	if (!advertisementHTML) {
		return <DefaultAd />;
	}

	return (
		<Box width={'100%'} height={'100%'} sx={{ backgroundColor: 'background.paper', ':hover': { cursor: 'pointer' } }}>
			{parse(advertisementHTML)}
		</Box>
	);
};

export default Ads;
